import { Routes, Route, Link, Outlet } from 'react-router-dom';
import './AccountWrapper.css';
import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { isBuyer, isSeller, getCurrentUser, isAuthed, isEventHost, isAdmin } from '../../services/auth.service';
import { FaComment, FaDot, FaCommentAlt, FaRegComment, FaUser, FaUsers, FaChartPie, FaRegEnvelope, FaUserCog, FaRegComments, FaLink, FaShapes, FaSearch, FaDotCircle, FaStar, FaMoneyCheck, FaRegStar, FaChartLine, FaSlidersH, FaVectorSquare, FaRegUser, FaTicketAlt, FaUserLock, FaDollarSign, FaQuestionCircle, FaUserCircle } from 'react-icons/fa';
import ProfileCard from '../dashboard/ProfileCard';
import { useEffect } from 'react';
import { getFeedUnreplyCount, publishCompany, getUserCompany, getMessageUnreadCount, hasUnreadMessages, adminCheck } from '../../utils/api';
import { refresh } from '../../services/auth.service';
import Support from '../../components/support/Support';
import useSubscriberStatus from '../../hooks/useSubscriberStatus';
import { hRefreshToken, addBuyerRole, addSellerRole } from '../../utils/api';
import {
  User,
  Users,
  Search,
  MessageSquare,
  Calendar,
  Clock,
  CheckSquare,
  BarChart,
  Mail,
  Settings,
  HelpCircle,
  ExternalLink,
  Shapes,
  DollarSign,
  PanelRightDashed,
  House,
  BarChart2,
  Unlock,
  Lock,
  Gift,
  X,
  ArrowBigUp,
  ArrowLeftRight
} from 'lucide-react';

function AccountWrapper({ view }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [unreplyCount, setUnreplyCount] = useState(0);
  const [userCompany, setUserCompany] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);
  const [hasCompany, setHasCompany] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);
  const [shortMenu, setShortMenu] = useState(false);
  const { subscriberStatus, subscriberLoading, subscriberData, subscriberError, refetch } = useSubscriberStatus();
  const [showUpgradeDialog, setShowUpgradeDialog] = useState(false);
  const [showSellerDialog, setShowSellerDialog] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [publishComplete, setPublishComplete] = useState(false);
  const [showPublishSuccess, setShowPublishSuccess] = useState(false);
  const [showBoostDialog, setShowBoostDialog] = useState(false);
  const [enablingBuyer, setEnablingBuyer] = useState(false);
  const [enablingSeller, setEnablingSeller] = useState(false);

  const currentUser = getCurrentUser();

  const [activeRole, setActiveRole] = useState(() => {
    console.log('is seller', isSeller());
    console.log('is buyer', isBuyer());
    let activeRole = localStorage.getItem('activeRole');
    console.log('Active Role:', activeRole);
    
    if (activeRole) {
      return activeRole;
    } else if (isBuyer()) {
      return 'buyer';
    } else if (isSeller()) {
      return 'seller';
    } else {
      return 'buyer'; // Default to buyer if no role is set
    }
  });

  async function handleEnableBuyer(){
      setEnablingBuyer(true);
  
      let res = await addBuyerRole();
  
      if (res.success){
        await hRefreshToken();
        window.location = '/dashboard/buyer';
      }
  
      else if (res.status === 403){
        await refresh();
  
        let res = await addBuyerRole();
  
        if (res.success){
          await hRefreshToken();
          window.location = '/dashboard/buyer';
        }
      }
    }

  async function handleEnableSeller() {
    setEnablingSeller(true);

    let res = await addSellerRole();

    if (res.success) {
      await hRefreshToken();
      handleRoleSwitch('seller');
      //window.location = '/dashboard/seller';
    }
    else if (res.status === 403) {
      await refresh();
      let res = await addSellerRole();
      if (res.success) {
        await hRefreshToken();
        handleRoleSwitch('seller');
       // window.location = '/dashboard/seller';
      }
    }
  }

  const handleRoleSwitch = (role) => {
    setActiveRole(role);
    localStorage.setItem('activeRole', role);

    if (role === 'buyer') {
      navigate('/dashboard/home');
    }

    if (role === 'seller') {
      navigate('/dashboard/performance');
    }
  };

  async function loadUserCompany() {
    let res = await getUserCompany();

    if (res.success) {
      setUserCompany(res.data);
    }

    else if (res.status === 403) {
      await refresh();
      let res = await getUserCompany();

      if (res.success) {
        setUserCompany(res.data);
      }
    }

    else {
      setHasCompany(false);
    }

    setLoaded(true);
  }

  async function loadUnreplyCount() {
    let res = await getFeedUnreplyCount();

    if (res.success) {
      setUnreplyCount(res.data);
    }

    else if (res.status === 403) {
      await refresh();
      let res = await getFeedUnreplyCount();

      if (res.success) {
        setUnreplyCount(res.data);
      }
    }
  }

  async function checkUnread() {
    let res = await hasUnreadMessages();

    if (res.success) {
      if (res.data) {
        setHasUnread(true);
      }

      else {
        setHasUnread(false);
      }
    }

    if (res.status === 403) {
      await refresh();

      let res = await hasUnreadMessages();

      if (res.success) {
        if (res.data) {
          setHasUnread(true);
        }

        else {
          setHasUnread(false);
        }
      }
    }
  }

  async function loadUnreadCount() {
    let res = await getMessageUnreadCount();

    if (res.success) {
      setUnreadCount(parseInt(res.data));
    }

    else if (res.status === 403) {
      await refresh();

      let res = await getMessageUnreadCount();

      if (res.success) {
        setUnreadCount(parseInt(res.data));
      }
    }
  }

  async function handlePublish() {
    setIsPublishing(true);

    let res = await publishCompany();

    if (res.success) {
      setIsPublishing(false);
      setPublishComplete(true);
      setShowSellerDialog(false);
      setShowPublishSuccess(true);

      // Reload company data
      await loadUserCompany();
    }
  }

  useEffect(() => {
    loadUnreplyCount();
    loadUserCompany();
    checkUnread();
    loadUnreadCount();
  }, []);

  const UpgradeDialog = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className="bg-white rounded-xl w-full max-w-lg mx-4 p-8">
          <div className="flex justify-between items-start mb-6">
            <div className="flex items-center space-x-3">
              <div className="bg-purple-100 rounded-lg p-3">
                <Search className="w-6 h-6 text-purple-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Unlock Prospect Search</h3>
                <p className="text-sm text-gray-500 mt-1">Find your ideal customers</p>
              </div>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="bg-purple-50 rounded-lg p-4 mb-6">
            <h4 className="font-semibold text-purple-900 mb-3">Why Upgrade?</h4>
            <ul className="space-y-2">
              <li className="flex items-center text-sm text-purple-800">
                <div className="w-1.5 h-1.5 rounded-full bg-purple-400 mr-2"></div>
                Access our database of qualified B2B buyers
              </li>
              <li className="flex items-center text-sm text-purple-800">
                <div className="w-1.5 h-1.5 rounded-full bg-purple-400 mr-2"></div>
                Filter by industry, company size, and technology stack
              </li>
              <li className="flex items-center text-sm text-purple-800">
                <div className="w-1.5 h-1.5 rounded-full bg-purple-400 mr-2"></div>
                Get real-time notifications when prospects view your profile
              </li>
              <li className="flex items-center text-sm text-purple-800">
                <div className="w-1.5 h-1.5 rounded-full bg-purple-400 mr-2"></div>
                Advanced analytics and engagement tracking
              </li>
            </ul>
          </div>

          <div className="flex items-center justify-end space-x-4">
            <button
              onClick={() => navigate('/buyer-directory')}
              className="px-4 py-2 text-gray-600 hover:text-gray-700 font-medium"
            >
              Check It Out
            </button>
            <button
              onClick={() => {
                navigate('/subscription');
                onClose();
              }}
              className="px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg font-medium hover:from-purple-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 shadow-md"
            >
              Upgrade to Pro →
            </button>
          </div>
        </div>
      </div>
    );
  };

  const SellerFeatureDialog = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className="bg-white rounded-xl w-full max-w-lg mx-4 p-8">
          <div className="flex justify-between items-start mb-6">
            <div className="flex items-center space-x-3">
              <div className="bg-purple-100 rounded-lg p-3">
                <Calendar className="w-6 h-6 text-purple-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Activate Seller Features</h3>
                <p className="text-sm text-gray-500 mt-1">Start hosting demos with potential buyers</p>
              </div>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="bg-purple-50 rounded-lg p-4 mb-6">
            <p className="text-gray-600 mb-4">
              To start managing demos and connecting with potential buyers, you'll need to activate seller features for your account.
            </p>

            <p className="text-sm text-purple-700">
              Once enabled, users will be able to book demos with you, and you'll have access to advanced analytics and engagement tracking.
            </p>
          </div>

          <div className="flex justify-end space-x-3">
            <button onClick={onClose} className="px-4 py-2 text-gray-600 hover:text-gray-700 font-medium">
              Maybe Later
            </button>

            <button
              onClick={() => handlePublish()}
              disabled={isPublishing}
              className="inline-flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
            >
              {isPublishing ? (
                <>
                  <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>Enabling...</span>
                </>
              ) : (
                <>
                  <Unlock className="h-3 w-3 text-purple-200 ml-2 text-gray-500" />
                  <span>Enable</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const PublishSuccessDialog = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className="bg-white rounded-xl w-full max-w-md mx-4 p-8 transform transition-all duration-300 ease-in-out">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
              <CheckSquare className="h-6 w-6 text-green-600" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Successfully Activated!</h3>
            <p className="text-sm text-gray-500 mb-6">
              Your seller features are now active. You can start managing demos and connecting with potential buyers.
            </p>
            <button
              onClick={() => {
                onClose();
                navigate('/dashboard/seller');
              }}
              className="w-full inline-flex justify-center items-center px-4 py-2 bg-gradient-to-r from-green-600 to-green-500 text-white rounded-lg hover:from-green-700 hover:to-green-600 transform transition-all duration-150"
            >
              Go to Dashboard →
            </button>
          </div>
        </div>
      </div>
    );
  };

  const BoostAnalyticsDialog = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className="bg-white rounded-xl w-full max-w-lg mx-4 p-8">
          <div className="flex justify-between items-start mb-6">
            <div className="flex items-center space-x-3">
              <div className="bg-purple-100 rounded-lg p-3">
                <BarChart2 className="w-6 h-6 text-purple-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Boost Your Visibility</h3>
                <p className="text-sm text-gray-500 mt-1">Unlock and track your newsletter campaign performance</p>
              </div>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="bg-purple-50 rounded-lg p-4 mb-6">
            <h4 className="font-semibold text-purple-900 mb-3">What are Boosts?</h4>
            <ul className="space-y-2">
              <li className="flex items-center text-sm text-purple-800">
                <div className="w-1.5 h-1.5 rounded-full bg-purple-400 mr-2"></div>
                Featured placement in our weekly newsletters
              </li>
              <li className="flex items-center text-sm text-purple-800">
                <div className="w-1.5 h-1.5 rounded-full bg-purple-400 mr-2"></div>
                Track impressions, clicks and engagement
              </li>
              <li className="flex items-center text-sm text-purple-800">
                <div className="w-1.5 h-1.5 rounded-full bg-purple-400 mr-2"></div>
                Reach thousands of qualified buyers
              </li>
              <li className="flex items-center text-sm text-purple-800">
                <div className="w-1.5 h-1.5 rounded-full bg-purple-400 mr-2"></div>
                Detailed campaign performance analytics
              </li>
            </ul>
          </div>

          <div className="flex items-center justify-end space-x-4">

            <Link
              to="/boost-visibility"
              className="px-4 py-2 text-purple-600 hover:text-purple-700 font-medium"
              onClick={onClose}
            >
              Learn More
            </Link>
            <button
              onClick={() => {
                navigate('/subscription');
                onClose();
              }}
              className="px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg font-medium hover:from-purple-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 shadow-md"
            >
              Upgrade to Pro →
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className='accountwrapper flex min-h-screen bg-gray-50'>
        <div className="w-82 bg-white border-r border-gray-200" style={{ borderRight: 'solid 1px #ddd' }}>
          <div style={{ borderBottom: 'solid 1px #ddd' }}>
            <ProfileCard />
          </div>

          {(isBuyer() === true || isSeller() === true || isEventHost() == true) && (
            <>
              <nav className="mt-4 px-8 sticky top-[20px]">

                <div className="space-y-1 accountmenu">
                  <div className=''>
                    {/* Render buyer menu only if activeRole is buyer */}
                    {isBuyer() && activeRole === 'buyer' && (
                      <>
                        <Link to='/dashboard/buyer'>
                          <PanelRightDashed className="h-5 w-5 mr-3 text-gray-500" />
                          <span className='accountwrapper__menu-item-name'>Dashboard</span>
                        </Link>

                        <div className='accountwrapper__submenu'>
                          <div className='accountwrapper__submenu-item'>
                            <Link to='/dashboard/home' className={view === "buyerhome" ? "selected" : ""}>
                              <House className="h-5 w-5 mr-3 text-gray-500" />
                              <span className='accountwrapper__menu-item-name'>Home</span>
                            </Link>
                          </div>
                        </div>

                        <div className='accountwrapper__submenu'>
                          <div className='accountwrapper__submenu-item'>
                            <Link to='/dashboard/buyer' className={view === "buyerdashboard" ? "selected" : ""}>
                              <Calendar className="h-5 w-5 mr-3 text-gray-500" />
                              <span className='accountwrapper__menu-item-name'>Manage Demos</span>
                            </Link>
                          </div>
                        </div>

                        <div className='accountwrapper__submenu'>
                          <div className='accountwrapper__submenu-item'>
                            <Link to='/dashboard/all-offers' className={view === "alloffers" ? "selected" : ""}>
                              <span><Gift className="h-5 w-5 mr-3 text-gray-500" /></span>
                              <span className='accountwrapper__menu-item-name'>Exclusive Offers</span>
                            </Link>
                          </div>
                        </div>
                      </>
                    )}

                    {/* Render seller menu only if activeRole is seller */}
                    {loaded == true && isSeller() && activeRole === 'seller' && (
                      <>
                        <div>
                          <Link to='/dashboard/seller'>
                            <PanelRightDashed className="h-5 w-5 mr-3 text-gray-500" />
                            <span className='accountwrapper__menu-item-name'>Seller Dashboard</span>
                          </Link>

                          <div className='accountwrapper__submenu'>
                            <div className='accountwrapper__submenu-item'>
                              <Link to='/dashboard/performance' className={view === "performance" ? "selected" : ""}>
                                <BarChart2 className="h-5 w-5 mr-3 text-gray-500" />
                                <span className='accountwrapper__menu-item-name'>Performance</span>
                              </Link>
                            </div>

                            <div className='accountwrapper__submenu-item'>
                              { userCompany?.is_seller ? (
                                <Link to='/dashboard/seller' className={view === "sellerdashboard" ? "selected" : ""}>
                                  <Calendar className="h-5 w-5 mr-3 text-gray-500" />
                                  <span className='accountwrapper__menu-item-name'>Manage Demos</span>
                                  <Unlock className="h-3 w-3 text-purple-500 ml-2 text-gray-500" />
                                </Link>
                              ) : (
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setShowSellerDialog(true);
                                  }}
                                  className={view === "sellerdashboard" ? "selected" : ""}
                                >
                                  <Calendar className="h-5 w-5 mr-3 text-gray-500" />
                                  <span className='accountwrapper__menu-item-name'>Manage Demos</span>
                                  <Lock className="h-3 w-3 text-purple-500 ml-2 text-gray-500" />
                                </Link>
                              )}
                            </div>

                            {userCompany && userCompany.company_id == 13011 && (
                              <div className='accountwrapper__submenu-item'>
                                <Link to='/search/buyers' className={view === "prospect" ? "selected" : ""}>
                                  <Search className="h-5 w-5 mr-3 text-gray-500" />
                                  <span className='accountwrapper__menu-item-name'>Buyer Directory</span>

                                </Link>
                              </div>
                            )}

                            {userCompany && userCompany.company_id != 13011 && (
                              <div className='accountwrapper__submenu-item'>
                                {subscriberLoading == false && subscriberData && subscriberData.length > 0 && (
                                  <Link to='/buyer-directory' className={view === "prospect" ? "selected" : ""}>
                                    <Search className="h-5 w-5 mr-3 text-gray-500" />
                                    <span className='accountwrapper__menu-item-name'>Buyer Directory</span>
                                    <Unlock className="h-3 w-3 text-purple-500 ml-2 text-gray-500" />
                                  </Link>
                                )}

                                {subscriberLoading == false && subscriberData && subscriberData.length == 0 && (
                                  <>
                                    <Link
                                      to="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setShowUpgradeDialog(true);
                                      }}
                                      className={view === "prospect" ? "selected" : ""}
                                    >
                                      <Search className="h-5 w-5 mr-3 text-gray-500" />
                                      <span className='accountwrapper__menu-item-name'>
                                        Buyer Directory
                                      </span>
                                      <Lock className="h-3 w-3 text-purple-500 ml-2 text-gray-500" />
                                    </Link>
                                  </>
                                )}
                              </div>
                            )}

                            <div className='accountwrapper__submenu-item'>
                              {subscriberLoading == false && subscriberData && subscriberData.length > 0 ? (
                                <Link
                                  to="/dashboard/campaigns"
                                  className={view === "boosts" ? "selected" : ""}
                                >
                                  <ArrowBigUp className="h-5 w-5 mr-3 text-gray-500" />
                                  <span className='accountwrapper__menu-item-name'>Boost Visibility</span>
                                  <Unlock className="h-3 w-3 text-purple-500 ml-2 text-gray-500" />
                                </Link>
                              ) : (
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setShowBoostDialog(true);
                                  }}
                                  className={view === "boosts" ? "selected" : ""}
                                >
                                  <ArrowBigUp className="h-5 w-5 mr-3 text-gray-500" />
                                  <span className='accountwrapper__menu-item-name'>Boost Visibility</span>
                                  <Lock className="h-3 w-3 text-purple-500 ml-2 text-gray-500" />
                                </Link>
                              )}
                            </div>

                            <div className='accountwrapper__submenu-item'>
                              <Link to='/dashboard/offers' className={view === "offers" ? "selected" : ""}>
                                <Gift className="h-5 w-5 mr-3 text-gray-500" />
                                <span className='accountwrapper__menu-item-name'>Manage Offers</span>
                              </Link>
                            </div>

                            <div className='accountwrapper__submenu-item'>
                              <Link to={'/account/team'} className={view === "team" ? "selected" : ""}>
                                <Users className="h-5 w-5 mr-3 text-gray-500" />

                                <span className='accountwrapper__menu-item-name'>
                                  Team
                                </span>
                              </Link>
                            </div>

                            <div className='accountwrapper__submenu-item'>
                              <Link to={'/account/qualifiers'} className={view === "qualifiers" ? "selected" : ""}>
                                <HelpCircle className="h-5 w-5 mr-3 text-gray-500" />
                                <span className='accountwrapper__menu-item-name'>Qualification Questions</span>
                              </Link>
                            </div>

                            <div className='accountwrapper__submenu-item'>
                              <Link to={'/account/icp'} className={view === "icp" ? "selected" : ""}>
                                <User className="h-5 w-5 mr-3 text-gray-500" />
                                <span className='accountwrapper__menu-item-name'>Ideal Customer Profile</span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {/* Keep event host menu outside role switching */}
                    {isEventHost() == true && (
                      <>
                        <div className='accountwrapper__submenu-item'>

                          <Link to='/account/events' className={view === "eventdashboard" ? "selected" : ""}>
                            <PanelRightDashed className="h-5 w-5 mr-3 text-gray-500" />

                            <span className='accountwrapper__menu-item-name'>Event Dashboard</span>
                          </Link>
                        </div>
                      </>
                    )}

                    {/* Keep the shared menu items */}
                    {isAuthed() == true && (isBuyer() == true || isSeller() == true) && (
                      <div className='accountwrapper__submenu-item'>

                        <Link to='/dashboard/inbox' className={view === "inbox" ? "selected" : ""}>
                          <Mail className="h-5 w-5 mr-3 text-gray-500" />

                          <span className='accountwrapper__menu-item-name'>
                            <span>Inbox</span>

                            {unreadCount > 0 && (
                              <span className='header__unread-badge ml-4'>
                                {unreadCount}
                              </span>
                            )}

                            {
                              unreadCount == 0 && (
                                <span className='header__unread-badge ml-4' style={{ backgroundColor: '#f2f2f2', color: '#aaa' }}>
                                  0
                                </span>
                              )
                            }
                          </span>
                        </Link>
                      </div>
                    )}

                    {/* {isSeller() && (
                      <div className='accountwrapper__submenu-item'>

                        <Link to='/account/addons' className={view === "addons" ? "selected" : ""}>
                          <Shapes className="h-5 w-5 mr-3 text-gray-500" />

                          <span className='accountwrapper__menu-item-name'>Add-ons</span>
                        </Link>
                      </div>
                    )} */}

                    <div className='accountwrapper__submenu-item'>
                      <Link to='/account/home' className={view === "settings" ? "selected" : ""}>
                        <Settings className="h-5 w-5 mr-3 text-gray-500" />

                        <span className='accountwrapper__menu-item-name'>
                          Settings
                        </span>
                      </Link>
                    </div>

                  </div>

                  {/* Replace dual role switcher with single toggle */}
                {isBuyer() && isSeller() && (
                  <div className="mb-4">
                    <button
                      onClick={() => handleRoleSwitch(activeRole === 'buyer' ? 'seller' : 'buyer')}
                      className="w-full px-3 py-2 text-sm font-medium rounded-md flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 transition-colors"
                    >
                      {activeRole === 'buyer' ? (
                        <>
                          <Users className="h-4 w-4 text-gray-600" />
                          <span className="text-gray-700">Switch to Seller View</span>
                          <ArrowLeftRight className="h-4 w-4 ml-1 text-gray-500" />
                        </>
                      ) : (
                        <>
                          <User className="h-4 w-4 text-gray-600" />
                          <span className="text-gray-700">Switch to Buyer View</span>
                          <ArrowLeftRight className="h-4 w-4 ml-1 text-gray-500" />
                        </>
                      )}
                    </button>
                  </div>
                )}
                </div>

                {!subscriberLoading && subscriberData && subscriberData.length == 0 && isSeller() == true && (
                  <div className="mt-8 bottom-4 mb-4 relative">
                    <div className="rounded-lg bg-gradient-to-r from-purple-600 to-indigo-600 p-4 shadow-lg">
                      <h3 className="text-sm font-medium text-white">Upgrade Your Account</h3>
                      <p className="mt-1 text-sm text-purple-100">Get access to all premium features</p>
                      <Link
                        to="/subscription"
                        className="mt-3 flex w-full items-center justify-center rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-white/20"
                      >
                        View Plans
                      </Link>
                    </div>
                  </div>
                )}

                {isBuyer() == false && (
                  <>
                    <div className="mt-8 bottom-4 mb-4 relative">
                      <div className="rounded-lg  p-4 shadow-lg">
                        <h3 className="text-sm font-medium"> Enable Buyer Role</h3>
                        <p className="mt-1 text-sm text-purple-500">
                          Start discovering software solutions.
                        </p>

                      {enablingBuyer == false && (
                        <button
                        onClick={() => handleEnableBuyer()}
                          to="/subscription"
                          className="mt-3 flex bg-gradient-to-r from-purple-600 to-indigo-600 w-full items-center justify-center rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-white/20"
                        >
                          Enable
                        </button>
                      )}

                      {enablingBuyer == true && (
                        <Link
                          to="#"
                          className="mt-3 bg-gradient-to-r from-purple-600 to-indigo-600 flex w-full items-center justify-center rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-white/20"
                        >
                          <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          <span> Enabling...</span>
                        </Link>
                      )}
                      </div>
                    </div>
                  </>
                )}

                {isSeller() == false && (
                  <div className="mt-8 bottom-4 mb-4 relative">
                    <div className="rounded-lg p-4 shadow-lg border border-gray-100">
                      <h3 className="text-sm font-medium">Enable Seller Role</h3>
                      <p className="mt-1 text-sm text-purple-500">
                        Start hosting demos <br/>
                        and connecting with buyers.
                      </p>

                      {enablingSeller == false && (
                        <button
                          onClick={() => handleEnableSeller()}
                          className="mt-3 flex bg-gradient-to-r from-indigo-600 to-blue-600 w-full items-center justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm hover:opacity-90"
                        >
                          <Users className="h-4 w-4 mr-2" />
                          Become a Seller
                        </button>
                      )}

                      {enablingSeller == true && (
                        <div className="mt-3 bg-gradient-to-r from-indigo-600 to-blue-600 flex w-full items-center justify-center rounded-md px-3 py-2 text-sm font-semibold text-white">
                          <svg className="animate-spin h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          <span>Enabling...</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </nav>
            </>
          )}
        </div>

        <div className='account__content'>
          <Outlet />
        </div>

        <UpgradeDialog
          isOpen={showUpgradeDialog}
          onClose={() => setShowUpgradeDialog(false)}
        />

        <SellerFeatureDialog
          isOpen={showSellerDialog}
          onClose={() => setShowSellerDialog(false)}
        />

        <PublishSuccessDialog
          isOpen={showPublishSuccess}
          onClose={() => setShowPublishSuccess(false)}
        />

        <BoostAnalyticsDialog
          isOpen={showBoostDialog}
          onClose={() => setShowBoostDialog(false)}
        />

        <Support />
      </div>
    </>
  );
}

export default AccountWrapper;
